import { createContext, useContext } from 'react';

import { RecentProjectsContext } from './types';

type RecentActions = Pick<RecentProjectsContext, 'saveRecentProject'>;

export const recentContext = createContext<RecentProjectsContext>({} as RecentProjectsContext);
export const recentActionContext = createContext<RecentActions>({} as RecentActions);

export function useRecentProjects(): RecentProjectsContext {
  const context = useContext(recentContext);

  if (!context.recentProjects) {
    throw new Error('useRecentProjects must be used within its provider');
  }

  return context;
}

export function useRecentProjectSetter(): RecentActions {
  const context = useContext(recentActionContext);

  if (!context.saveRecentProject) {
    throw new Error('useRecentProjectsActions must be used within its provider');
  }

  return context;
}
